import { createContext } from "react";
import type { ThemePreference } from "../lib/theme-settings.js";
import type { DensityPreference } from "../lib/density-settings.js";

export interface ThemeContextValue {
  theme: ThemePreference;
  setTheme: (t: ThemePreference) => void;
  density: DensityPreference;
  setDensity: (d: DensityPreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
